// Load Dependencies
import React, { Component } from "react";
import { connect } from "react-redux";

import { configurationsStoreSelectors } from "../../../../store/store";

import { ActionCreator } from "../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../actions/actionCreators";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { Dialog } from "../../../../../../utils/Dialog/Dialog.component";


import "./MailingConfigurationSection.component.scss";
import { ConfigurationsActionTypes } from "../../../../actions/actionTypes";

export interface MailingConfigurationSectionProps {
    mailingLists: any;
    mailingListsLoading: boolean;
    editingConfiguration: any;
    editingConfigurationLoading: boolean;
    configSectionVisited: ActionCreator;
    getMailingLists: ActionCreator;
    updateMailingListsConfiguration:ActionCreator;
    isDetails?:boolean;
}

export interface MailingConfiguration {
    mailingListsValue: string,
    showResetNotification:boolean
}

class MailingConfigurationSection extends Component<
    MailingConfigurationSectionProps,
    MailingConfiguration
> {

    constructor(props) {
        super(props);
        this.state = {
            mailingListsValue: "",
            showResetNotification: false
        };
    }
    componentDidMount() {
        this.props.configSectionVisited(
            ConfigurationsActionTypes.UPDATE_MAILING_CONFIG
        );
        this.props.getMailingLists(
            this.props.editingConfiguration.subsidiary.id
        );
    }

    onChangeMailingLists = value => {
        const index = this.props.mailingLists.findIndex(list =>
            list.id === value
        )
        if (index > -1) {
            if(this.state.mailingListsValue === "" &&
                this.props.editingConfiguration.settings.settings.mailing_lists &&
                this.props.editingConfiguration.settings.settings.mailing_lists.length > 0){
                this.setState({
                    showResetNotification: true,
                    mailingListsValue: value
                })
            } else {
                this.setState({ mailingListsValue: value })
                this.props.updateMailingListsConfiguration(this.props.mailingLists[index], this.props.mailingLists[index].lists.length >0);
            }
        }
    };

    onDialogConfirm = () => {
        const index = this.props.mailingLists.findIndex(list =>
            list.id === this.state.mailingListsValue
        )
        if (index > -1) {
            this.props.updateMailingListsConfiguration(this.props.mailingLists[index], this.props.mailingLists[index].lists.length >0);
        }
        this.setState({
            showResetNotification: false
        });
    };

    onDialogClose = () => {
        this.setState({
            showResetNotification: false,
            mailingListsValue: ""
        });
    };


    render() {
        if (this.props.mailingListsLoading) {
            return (
                <div id="MailingConfigurationSectionSection">
                    <div className="loading" key="loading">
                        <Components.LoadingRipple width={100} height={100} />
                    </div>
                </div>
            );
        }

        return (
            <div id="MailingConfigurationSectionSection">
                {!this.props.mailingListsLoading &&
                    this.props.mailingLists.length == 0 &&
                    (
                        <div className="row">
                            <div className="no-mailing-lists">
                                <p>
                                    <i className="icon-exclamation-circle-light"></i>
                                    There are no mailing list active for this
                                    subsidiary. Without mailing lists reports can
                                    not be sent by e-mail. Please configure mailing
                                    lists for this subsidiary or contact an
                                    administrator.
                                </p>
                            </div>
                        </div>
                    )}
                {!this.props.mailingListsLoading &&
                this.props.mailingLists.length > 0 &&
                    !this.props.isDetails &&
                    <div className="mailing-list-select">
                        <div className="select-list">
                            <label className="label">
                                Mailing List
                            </label>
                            <Components.SelectMenu
                                key={this.state.mailingListsValue}
                                noValueLabel="Choose Mailing List"
                                items={
                                    this.props.mailingLists
                                        ? this.props.mailingLists.map(
                                            ver => {
                                                return {
                                                    value: ver.id,
                                                    label: ver.name
                                                };
                                            }
                                        )
                                        : []
                                }
                                onChange={this.onChangeMailingLists}
                                value={this.state.mailingListsValue}
                            />
                        </div>
                    </div>
                }
                {!this.props.editingConfigurationLoading &&
                    this.props.editingConfiguration.settings.settings.mailing_lists &&
                    this.props.editingConfiguration.settings.settings.mailing_lists.length > 0 &&
                    (
                        <div className="row">
                            {this.props.editingConfiguration.settings.settings.mailing_lists.map(list => {
                                return (
                                    <div key={list.key} className="col-4">
                                        <h2>{list.name}</h2>
                                        <ul>
                                            {list.mails.map(mail => {
                                                return (
                                                    <li key={mail.address}>
                                                        {mail.address}{" "}
                                                        <span>
                                                        {mail.removable
                                                            ? "(removable)"
                                                            : ""}
                                                    </span>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                <Dialog
                    open={this.state.showResetNotification}
                    onConfirm={this.onDialogConfirm}
                    onClose={this.onDialogClose}
                >
                    You are about to replace the current mailing list and you might not be able to revert the changes. Do you want to continue?
                </Dialog>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    mailingListsLoading: configurationsStoreSelectors.mailingListsLoading(
        state
    ),
    mailingLists: configurationsStoreSelectors.mailingLists(state),
    editingConfiguration: configurationsStoreSelectors.editingConfiguration(
        state
    ),
    editingConfigurationLoading: configurationsStoreSelectors.editingConfigurationLoading(
        state
    )
});

const mapDispatchToProps = {
    configSectionVisited: ConfigurationsActionCreators.configSectionVisited,
    getMailingLists: ConfigurationsActionCreators.getMailingLists,
    updateMailingListsConfiguration: ConfigurationsActionCreators.updateMailingListsConfiguration
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MailingConfigurationSection);
